// extracted by mini-css-extract-plugin
export var divider = "_3a-0";
export var dividerText = "_3a-1";